<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Comissões Não Registradas"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="bfluenceIntegrityService"
  pageFunctionName="getUnregisteredSubCommissionTable"
  emptyMessage="Sem mais comissões não registradas no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="registros"
  [defaultRows]="10"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
